"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeKey = exports.cancelButtonName = exports.confirmButtonName = exports.inlineEditClasses = exports.rawTextClasses = void 0;
var rawTextClasses = {
  container: 'bds-textfield-container',
  label: 'bds-label',
  secondaryLabel: 'bds-secondary-label',
  labelDisabled: 'bds-label-disabled',
  helperText: 'bds-helper-text',
  helperTextDisabled: 'bds-helper-text-disabled',
  inputContainer: 'bds-inline-edit-input-container',
  inputContainerErrorBorder: 'bds-input-container-error-border',
  inputBox: 'bds-input-box',
  inputIcon: 'bds-input-icon',
  errorMsgText: 'bds-error-msg-text',
  variantNaked: 'bds-naked',
  variantInline: 'bds-inline',
  inputContainerFocus: 'bds-input-container-focus',
  inputBoxWrapper: 'bds-input-box-wrapper',
  iconBox: 'bds-inline-edit-icon-box',
  inputWithIcon: 'bds-input-with-icon',
  inputContainerDisabled: 'bds-inline-edit-input-container-disabled',
  inputBoxDisabled: 'bds-input-box-disabled',
  inputBoxReadOnly: 'bds-input-box-read-only'
};
exports.rawTextClasses = rawTextClasses;
var inlineEditClasses = {
  inputBoxReadOnly: 'bds-inline-edit-input-box-box-read-only',
  inputBoxError: 'bds-inline-edit-input-box-box-error',
  inlineEditButtons: 'bds-inline-edit-input-box-buttons',
  inputContainerReadOnly: 'bds-inline-edit-input-container-read-only',
  variantNakedEmpty: 'bds-inline-edit-naked-empty',
  variantNakedError: 'bds-inline-edit-naked-error'
};
exports.inlineEditClasses = inlineEditClasses;
var confirmButtonName = 'inline-edit-confirm';
exports.confirmButtonName = confirmButtonName;
var cancelButtonName = 'inline-edit-cancel';
exports.cancelButtonName = cancelButtonName;
var escapeKey = 'Escape';
exports.escapeKey = escapeKey;